// extracted by mini-css-extract-plugin
export default {"mobile-device":"vlhA3n","mobileDevice":"vlhA3n","mobile-device-knob":"o5dpTa","mobileDeviceKnob":"o5dpTa"};